import { EsocialModule } from "../interface/esocial";

export const mockEsocial: EsocialModule = {
    fields: [
        {
            "reference": "candidate/info-pessoal/nome",
            "title": "NOME",
            "kind": "name"
        },
        {
            "reference": "candidate/info-pessoal/dataNascimento",
            "title": "NASCIMENTO", 
            "kind": "date"
        }, 
        {
            "reference": "candidate/cpf/numero",
            "title": "CPF",
            "kind": "cpf"
        }, 
        { 
            "reference": "candidate/pis/numero",
            "title": "PIS",
            "kind": "pis"
        }
    ], 
    kind: "esocial",
    show: true,
    status: "not_validated"
}